import { DocumentInternalReminder } from '../dto/document-details.dto';

export interface IReminderDataSource {
    document_internal_reminder?: DocumentInternalReminder[];
    is_reminders_expire?: boolean;
}

export function getReminders(item: IReminderDataSource): DocumentInternalReminder[] {
    return (item?.document_internal_reminder || [])
        .filter(reminder => !!reminder?.reminder_datetime)
        .sort((a, b) => new Date(b.reminder_datetime).getTime() - new Date(a.reminder_datetime).getTime());
}

export function hasReminder(item: IReminderDataSource): boolean {
    return getReminders(item).length > 0;
}

export function isReminderExpired(item: IReminderDataSource): boolean {
    if (typeof item?.is_reminders_expire === 'boolean') {
        return item.is_reminders_expire;
    }

    const reminders = getReminders(item);
    if (!reminders.length) {
        return false;
    }

    return reminders.every(reminder => new Date(reminder.reminder_datetime).getTime() < Date.now());
}

export function getReminderUsersText(reminder: DocumentInternalReminder): string {
    return getReminderUsers(reminder) || 'N/A';
}

export function getReminderMessageText(reminder: DocumentInternalReminder): string {
    return reminder?.message?.trim() || '-';
}

export function getReminderDateText(reminder: DocumentInternalReminder, locale = 'en-US'): string {
    return formatReminderDate(reminder?.reminder_datetime, locale);
}

function getReminderUsers(reminder: DocumentInternalReminder): string {
    return (reminder?.users || [])
        .map(user => user?.name || user?.email)
        .filter(Boolean)
        .join(', ');
}

function formatReminderDate(value: string, locale = 'en-US'): string {
    if (!value) {
        return '-';
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }

    return new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    }).format(date);
}
